import React from 'react'
import { NavLink } from 'react-router-dom'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Testimonial from '../../component/Page/Testimonial'

const Membership = () => {
    const data = [
        {
            title: "follow-up per month",
            path_1: "1",
            path_2: "4",
            path_3: "30",
            type: "text",
        },
        {
            title: "Personalized Nutrition Program to Help You Reach Goals",
            path_1: "./../images/rt (3).png",
            path_2: "./../images/rt (3).png",
            path_3: "./../images/rt (3).png",
            type: "img",
        },
        {
            title: "Supplement plan (optional)",
            path_1: "./../images/rt (3).png",
            path_2: "./../images/rt (3).png",
            path_3: "./../images/rt (3).png",
            type: "img",
        },
        {
            title: "Adjust nutrition plan every 30 days based on commitment.",
            path_1: "./../images/rt (3).png",
            path_2: "./../images/rt (3).png",
            path_3: "./../images/rt (3).png",
            type: "img",
        },
        {
            title: "Progress tracking sheet to monitor your journey",
            path_1: "./../images/rt (3).png",
            path_2: "./../images/rt (3).png",
            path_3: "./../images/rt (3).png",
            type: "img",
        },
        {
            title: "Medical test review",
            path_1: "./../images/rt (3).png",
            path_2: "./../images/rt (3).png",
            path_3: "./../images/rt (3).png",
            type: "img",
        },
        {
            title: "Flexible meal options with budget-friendly choices",
            path_1: "./../images/rt (3).png",
            path_2: "./../images/rt (3).png",
            path_3: "./../images/rt (3).png",
            type: "img",
        },
      
    ]
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="medium font__size--14 text__14-1024 btn__tag mb-3">Membership</div>

                        <h2 className="medium font__size--40 text__40-1024 text__40-md text__40-mm">Your dream body <br className='d-none d-md-block' /> starts right here...</h2>
                    </div>

                    <div className="wrapper__offsite-wrap">
                        <div className="wrapper__table-compare-group">
                        <div className="row mb-5 justify-content-end">
                        <div className="col-9" style={{ maxWidth: "100%" }}>
                            <div className="row justify-content-center flex-nowrap">
                    <div className="col-4">
                        <div className="wrapper__price-list">
                            <h4 className="medium font__size--40 text__40-1024 text__40-md text__40-mm mb-3">EGP750<sub className="medium font__size--16 text__16-1024 color__gray-2">/<span style={{ textDecoration: 'line-through' }}>1500</span></sub></h4>
                            <p className="medium font__size--20 text__20-1024 color__purple mb-0">SILVER</p>

                            <ul className="list__data-detail medium font__size--18 text__18-1024 my-4">
                                <li>
                                <div className="d-flex align-items-start">
  <img src="./../images/asa.png" className='object-fit-content' alt="" />
  <span className="ml-2">
    <span
      style={{
        backgroundColor: '#FFD700',   // gold highlight
        color: '#000',                 // black text for contrast
        fontWeight: '600',             // bold
        padding: '2px 6px',            // some spacing around the word
        borderRadius: '4px'            // soft rounded corners
      }}
    >
      Monthly
    </span>{' '}
    follow-up with Dr. Aya Belal via WhatsApp during working hours.
  </span>
</div>
                                </li>
                                
                            </ul>

                            <NavLink
                    to="/contact" className="medium font__size--16 text__16-1024 btn btn__purple shadow rounded__50 color__white w-100 text-center">Get Silver</NavLink>

                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="wrapper__price-list bg__blue">
                                            <h4 className="medium font__size--40 text__40-1024 text__40-md text__40-mm mb-3 color__white">EGP1000<sub className="medium font__size--16 text__16-1024 color__gray-3">/<span style={{ textDecoration: 'line-through' }}>2000</span></sub></h4>
                                            <p className="medium font__size--20 text__20-1024 color__purple mb-0">GOLDEN</p>

                                            <ul className="list__data-detail medium font__size--18 text__18-1024 my-4 color__white">
                                <li>
                                    <div className="d-flex align-items-start">
  <img src="./../images/fsdfdsf.png" className='object-fit-content' alt="" />
  <span className="ml-2">
    <span
      style={{
        backgroundColor: '#FFD700',   // gold highlight
        color: '#000',                 // black text for contrast
        fontWeight: '600',             // bold
        padding: '2px 6px',            // some spacing around the word
        borderRadius: '4px'            // soft rounded corners
      }}
    >
      Weekly
    </span>{' '}
    follow-up with Dr. Aya Belal via WhatsApp during working hours.
  </span>
</div>
                                </li>
                                                            </ul>

                                                            <NavLink
                    to="/contact" className="medium font__size--16 text__16-1024 btn btn__purple shadow rounded__50 color__white w-100 text-center">Get Golden</NavLink>

                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="wrapper__price-list">
                                            <h4 className="medium font__size--40 text__40-1024 text__40-md text__40-mm mb-3">EGP1500<sub className="medium font__size--16 text__16-1024 color__gray-2">    /<span style={{ textDecoration: 'line-through' }}>3000</span>
                                            </sub></h4>                                                                            
                                            <p className="medium font__size--20 text__20-1024 color__purple mb-0">PREMIUM</p>
                                            <ul className="list__data-detail medium font__size--18 text__18-1024 my-4">
                                <li>
                                <div className="d-flex align-items-start">
  <img src="./../images/asa.png" className='object-fit-content' alt="" />
  <span className="ml-2">
    <span
      style={{
        backgroundColor: '#FFD700',   // gold highlight
        color: '#000',                 // black text for contrast
        fontWeight: '600',             // bold
        padding: '2px 6px',            // some spacing around the word
        borderRadius: '4px'            // soft rounded corners
      }}
    >
      Daily
    </span>{' '}
    follow-up with Dr. Aya Belal via WhatsApp during working hours.
  </span>
</div>
                                </li>
                                                           </ul>
                                                           <NavLink
                    to="/contact" className="medium font__size--16 text__16-1024 btn btn__purple shadow rounded__50 color__white w-100 text-center">Get Premium</NavLink>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="table head text-center">
                                <col class="w-f-first" />
                                <thead>
                                    <tr className='text-center'>
                                        <th scope="col" className=' semi-bold font__size--18 text__18-1024 text-left color__blue'>Overview</th>
                                        <th scope="col">

                                        </th>
                                        <th scope="col">

                                        </th>
                                        <th scope="col">

                                        </th>
                                    </tr>
                                </thead>
                                <tbody className='medium font__size--16 text__16-1024'>
                                    {
                                        data.map((obj) => {
                                            return <tr>
                                                <th scope="row" cl
                                                    className='text-left normal'>
                                                    <div className="d-flex align-items-center">
                                                        <span className='medium font__size--18 text__18-1024'>{obj.title}</span>
                                                    </div>
                                                </th>
                                                <td>
  {obj.type === "text" ? (
    <span
      style={{
        backgroundColor: "#FFD700", // gold
        color: "#000",
        fontWeight: "600",
        padding: "2px 6px",
        borderRadius: "4px"
      }}
    >
      {obj.path_1}
    </span>
  ) : (
    <img src={obj.path_1} alt="" />
  )}
</td>
<td>
  {obj.type === "text" ? (
    <span
      style={{
        backgroundColor: "#FFD700",
        color: "#000",
        fontWeight: "600",
        padding: "2px 6px",
        borderRadius: "4px"
      }}
    >
      {obj.path_2}
    </span>
  ) : (
    <img src={obj.path_2} alt="" />
  )}
</td>
<td>
  {obj.type === "text" ? (
    <span
      style={{
        backgroundColor: "#FFD700",
        color: "#000",
        fontWeight: "600",
        padding: "2px 6px",
        borderRadius: "4px"
      }}
    >
      {obj.path_3}
    </span>
  ) : (
    <img src={obj.path_3} alt="" />
  )}
</td>

                                            </tr>
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </section>

            <Testimonial />

            <Footer />
        </div>
    )
}

export default Membership